module.exports = __webpack_public_path__ + "static/media/linkedin.14f7b675.svg";